import { render, staticRenderFns } from "./DataProcessingTable.vue?vue&type=template&id=1dda4d1b&scoped=true"
import script from "./DataProcessingTable.vue?vue&type=script&lang=js"
export * from "./DataProcessingTable.vue?vue&type=script&lang=js"
import style0 from "./DataProcessingTable.vue?vue&type=style&index=0&id=1dda4d1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dda4d1b",
  null
  
)

export default component.exports